import { AnimationFrame } from "./AnimationFrame";
import { mat4 } from "gl-matrix";

export type JointType = {
    reference: string,
    animationFrames: { [key: string]: AnimationFrame[] };
};

export abstract class Animation {
    public reference: string;
    public bindShapeMatrix: mat4;
    public invBindShapeMatrix: mat4;
    public validAnimation: boolean;
    public joints: JointType[];
}
